namespace Portico.Directives {
	import ps = Portico.Services;

	export interface ITcSelectController {
		change: () => void;
		disabled: string;
		inputClass: string;
		isAllowed: () => boolean;
		key: string;
		list: string;
		listLabel: string;
		listOptions: string;
		listTrackBy: string;
		listValue: string;
		placeholder: string;
		readonly: string;
		required: string;

		tcForm: ITcFormController;

		isDisabled: () => boolean;
		onChange: () => void;
	}

	export class TcSelectController implements ITcSelectController {
		change: () => void;
		disabled: string;
		inputClass: string;
		isAllowed: () => boolean;
		key: string;
		list: string;
		listLabel: string;
		listOptions: string;
		listTrackBy: string;
		listValue: string;
		placeholder: string;
		readonly: string;
		required: string;

		tcForm: ITcFormController;

        isDisabled(): boolean {
            if (this.disabled === 'true' || (this.tcForm && this.tcForm.isDisabled())) {
                return true;
            }

            if (this.isAllowed && !this.isAllowed()) {
                return true;
            }

            return false;
        }

		onChange(): void {
			if (this.change) {
				this.change();
			}
		}
	}

	angular.module('app')
		.directive('tcSelect', [
			'$compile',
			'$stateParams',
			'dataService', (
				$compile: angular.ICompileService,
				$stateParams: angular.ui.IStateParamsService,
				dataService: ps.IDataService) => {
				return {
					bindToController: {
						change: '&?',
						disabled: '@',
						inputClass: '@',
						isAllowed: '&?',
						key: '@',
						list: '=',
						listLabel: '@',
						listOptions: '@',
						listTrackBy: '@',
						listValue: '@',
						placeholder: '@',
						readonly: '@',
						required: '@'
					},
					controller: <any>TcSelectController,
					controllerAs: '$select',
					link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[], $transclude: any) => {
						const tcSelect: ITcSelectController = $ctrl[0];
						const tcForm: ITcFormController = $ctrl[1];

						if (tcForm) {
							tcSelect.tcForm = tcForm;
							//tcForm.tcSelects.push(tcSelect);
						}

						const key: string = tcSelect.key ? tcSelect.key : '';
						const id: string = key.replace(/[\.\'\$\[\]\(\)]+/g, '_');

						const inputClass = tcSelect.inputClass ? ' ' + tcSelect.inputClass : '';
						let inputAttrs = '';
						let placeholderOption = '';
						let transclusion = '';

						$transclude(function (clone, scope) {
							clone.each(function (index, node) {
								transclusion += node.textContent ? node.textContent : node.outerHTML;
							});
						});

						transclusion = transclusion.trim();

						if (tcSelect.disabled) {
							inputAttrs += `disabled="${tcSelect.disabled}" `;
						}

						if (tcSelect.placeholder) {
							placeholderOption += `<option value="">${tcSelect.placeholder}</option>`;
						}

						if (tcSelect.readonly) {
							inputAttrs += `readonly="${tcSelect.readonly}" `;
						}

						if (tcSelect.required) {
							if (dataService.session.mode !== 'edit' && dataService.session.mode !== 'mock') {
								inputAttrs += `required="${tcSelect.required}" `;
							}
						}

						const itemLabel = (transclusion !== '' ? transclusion : (tcSelect.listLabel ? `{{item.${tcSelect.listLabel}}}` : '{{item}}')).replace(/"/g, '&quot;');
						const itemValue = (tcSelect.listValue ? `item.${tcSelect.listValue}` : 'item');

						let html;
						if (tcSelect.listOptions) {
							html =
								`<select class="form-control ${inputClass}" id="${id}-input" name="${id}" ng-change="$select.onChange()" ng-disabled="$select.isDisabled()" ng-model="${key}" ng-options="${tcSelect.listOptions}" ${inputAttrs}>
									${placeholderOption}
								</select>`;
						} else if (tcSelect.listTrackBy) {
							html =
								`<select class="form-control ${inputClass}" id="${id}-input" name="${id}" ng-change="$select.onChange()" ng-disabled="$select.isDisabled()" ng-model="${key}" ${inputAttrs}>
								${placeholderOption}
								<option value="{{${itemValue}}}" ng-repeat="item in $select.list track by item.${tcSelect.listTrackBy}">
									${itemLabel}
								</option>
							</select>`;
						} else {
							html =
								`<select class="form-control ${inputClass}" id="${id}-input" name="${id}" ng-change="$select.onChange()" ng-disabled="$select.isDisabled()" ng-model="${key}" ${inputAttrs}>
									${placeholderOption}
									<option value="{{${itemValue}}}" ng-repeat="item in $select.list">
										${itemLabel}
									</option>
								</select>`;
						}

						$element.html(html);
						$compile($element.contents() as any)($scope);
					},
					restrict: 'E',
					require: ['tcSelect', '?^tcForm'],
					scope: true,
					transclude: true
				};
			}
		]);
}